import axios from 'axios';

// App Imports
//import setAuthorizationToken from '../../components/utils/setAuthorizationToken';
import { rutas } from '../../routes_backend/routes.jsx';

export const USER_REQUEST = 'USERS_LIST_REQUEST';
export const USER_RESPONSE = 'USERS_LIST_RESPONSE';
export const USER_FAILURE = 'USERS_LIST_FAILURE';

export function getUser(user, password) {
	let url = `${rutas.get_conectaBD_SL}`;
	return (dispatch) => {
		dispatch({
			type: USER_REQUEST
		});

		return axios
			.get(url)
			.then(async (response) => {
				const res = await response.data;
				dispatch({
					type: USER_RESPONSE,
					user: res
				});
			})
			.catch((error) => {
				dispatch({
					type: USER_FAILURE,
					error: error
				});
			});
	};
}

export const USER_REQUEST_RESET = 'USERS_LIST_REQUEST_RESET';
export const USER_RESPONSE_RESET = 'USERS_LIST_RESPONSE_RESET';
export const USER_FAILURE_RESET = 'USERS_LIST_FAILURE_RESET';

export function resetPassword(email, password, token) {
	let url = `${rutas.reset_password}?email=${email}&password=${password}&token=${token}`;
	return (dispatch) => {
		dispatch({
			type: USER_REQUEST_RESET
		});

		return axios
			.get(url)
			.then(async (response) => {
				const res = await response.data;
				dispatch({
					type: USER_RESPONSE_RESET,
					resetpassword: res
				});
			})
			.catch((error) => {
				dispatch({
					type: USER_FAILURE_RESET,
					error: error
				});
			});
	};
}
